import React, { useState } from 'react';
import { styles } from './OldApplianceRemovalSection.css';
import { formatMoney } from '@jbhi-fi/lanyard-ui/global/utils';
import Spinner from '@jbhi-fi/lanyard-ui/components/Spinner';
import RadioCard from '@jbhi-fi/lanyard-ui/components/RadioCard';
import { InstallAccessorySection } from './InstallAccessorySection';

const OPTION = {
  REMOVE: 'remove',
  NO: 'no',
};

export type OldApplianceRemovalSectionProps = {
  applianceLabel?: string;
  price: number;
  isSelected: boolean;
  isDisabled: boolean;
  onSelect: () => void;
  onDeselect: () => void;
  isLoading: boolean;
  isNarrowLayout: boolean;
};

export const OldApplianceRemovalSection = ({
  applianceLabel,
  price,
  isSelected,
  isDisabled,
  onSelect,
  onDeselect,
  isLoading,
  isNarrowLayout,
}: OldApplianceRemovalSectionProps) => {
  const [hasUserSelected, setHasUserSelected] = useState(false);

  const handleClick = (value: string) => {
    if (isDisabled) return;
    setHasUserSelected(true);
    if (value === OPTION.REMOVE) {
      onSelect?.();
      return;
    }
    onDeselect?.();
  };

  const choices = [
    {
      id: 'remove_old_appliance',
      heading: `Remove old ${applianceLabel}`,
      message: `${formatMoney(price)}`,
      name: OPTION.REMOVE,
      value: OPTION.REMOVE,
      className: styles.option({ isSelected: isSelected && !isLoading && hasUserSelected }),
      checked: isSelected && hasUserSelected,
    },
    {
      id: 'keep_old_appliance',
      heading: 'No thanks',
      message: undefined,
      name: OPTION.NO,
      value: OPTION.NO,
      className: styles.option({ isSelected: !isSelected && !isLoading && hasUserSelected }),
      checked: !isSelected && hasUserSelected,
    },
  ];

  return (
    <InstallAccessorySection
      heading={`Need your old ${applianceLabel} removed?`}
      subheading={`We can take old ${applianceLabel}s of a similar type and size away for e-waste recycling.`}
      isNarrowLayout={isNarrowLayout}
    >
      <div className={styles.options}>
        {choices.map(choice => (
          <RadioCard
            key={choice.id}
            id={choice.id}
            name={choice.name}
            value={choice.value}
            checked={choice.checked}
            onClick={() => handleClick(choice.value)}
            className={choice.className}
            showRadioButton={false}
          >
            {isLoading && choice.checked ? (
              <div className={styles.optionSpinnerWrapper}>
                <Spinner />
              </div>
            ) : (
              <div className={styles.optionContentWrapper}>
                {choice.heading ? (
                  <div className={styles.optionHeading({ isSelected: choice.checked })}>{choice.heading}</div>
                ) : null}
                {choice.message ? (
                  <div className={styles.optionMessage({ isSelected: choice.checked })}>{choice.message}</div>
                ) : null}
              </div>
            )}
          </RadioCard>
        ))}
      </div>
    </InstallAccessorySection>
  );
};
